import { useState, useEffect } from "react";
import { ExpenseStatsData } from "../../@types";
import { getExpenseStats } from "../../backend-services";

export function useExpenseStatsData(startDate: Date, endDate: Date) {
  const [expenseData, setExpenseData] = useState<ExpenseStatsData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const fetchData = async () => {
    try {
      const response = await getExpenseStats(
        startDate.toISOString(),
        endDate.toISOString(),
      );
      setExpenseData(response);
      setError(null);
    } catch (error) {
      setError("Failed to fetch expense statistics");
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return { expenseData, error };
}
